import apiClient from './apiClient';
import { MedicineReturn, CreateMedicineReturnRequest, UpdateMedicineReturnRequest, MedicineReturnSummary } from '../types/MedicineReturn';

export const medicineReturnService = {
  getAllReturns: async (): Promise<MedicineReturn[]> => {
    const response = await apiClient.get('/medicinereturns');
    return response.data;
  },

  getReturn: async (id: number): Promise<MedicineReturn> => {
    const response = await apiClient.get(`/medicinereturns/${id}`);
    return response.data;
  },

  getReturnsByPatient: async (patientId: number): Promise<MedicineReturn[]> => {
    const response = await apiClient.get(`/medicinereturns/patient/${patientId}`);
    return response.data;
  },

  getReturnsByBill: async (billId: number): Promise<MedicineReturn[]> => {
    const response = await apiClient.get(`/medicinereturns/bill/${billId}`);
    return response.data;
  },

  getReturnsByStatus: async (status: string): Promise<MedicineReturn[]> => {
    const response = await apiClient.get(`/medicinereturns/status/${encodeURIComponent(status)}`);
    return response.data;
  },

  getPendingReturns: async (): Promise<MedicineReturn[]> => {
    const response = await apiClient.get('/medicinereturns/pending');
    return response.data;
  },

  getReturnSummary: async (): Promise<MedicineReturnSummary> => {
    const response = await apiClient.get('/medicinereturns/summary');
    return response.data;
  },

  createReturn: async (returnRequest: CreateMedicineReturnRequest): Promise<MedicineReturn> => {
    const response = await apiClient.post('/medicinereturns', returnRequest);
    return response.data;
  },

  updateReturn: async (id: number, returnRequest: UpdateMedicineReturnRequest): Promise<void> => {
    await apiClient.put(`/medicinereturns/${id}`, returnRequest);
  },

  approveReturn: async (id: number): Promise<MedicineReturn> => {
    const response = await apiClient.post(`/medicinereturns/${id}/approve`);
    return response.data;
  },

  rejectReturn: async (id: number, rejectionNotes?: string): Promise<MedicineReturn> => {
    const response = await apiClient.post(`/medicinereturns/${id}/reject`, JSON.stringify(rejectionNotes), {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  completeReturn: async (id: number): Promise<MedicineReturn> => {
    const response = await apiClient.post(`/medicinereturns/${id}/complete`);
    return response.data;
  },

  deleteReturn: async (id: number): Promise<void> => {
    await apiClient.delete(`/medicinereturns/${id}`);
  }
};
